export enum OrderType {
  Ascending = 0,
  Descending = 1,
}

export interface SortModel {
  field: string;
  order: OrderType;
}
